import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import { useDropzone } from "react-dropzone";
import AppBars from "../AppBar/AppBar";
import Listitems from "../ListItems/ListItems";
import { useNavigate } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob"; // Azure Blob Storage SDK
import YourChildComponent from "./YourChildComponent";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress
import { sasToken, containerName } from "../Global";
import { DrawerHeader, Drawer } from "../Global";

export default function FileUpload() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(!isSmallScreen); // Closed by default on small screens
  // const [fileType, setFileType] = React.useState("");
  const [fileTypePath, setFileTypePath] = React.useState();
  const [files, setFile] = React.useState(null);
  const [error, setError] = React.useState(""); // Error state to show if the wrong file type is uploaded
  const navigate = useNavigate();
  const [showModel, setShowModel] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const storageAccountName = "dspkstorage"; // Your Azure storage account name

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleNavigation = (text) => {
    if (text === "Private Collections") {
      navigate("/dataset/list/private");
    }
    if (text === 'Shared Collections') {
      navigate('/dataset/list/shared');
    }
    if (text === "Collections") {
      navigate("/dataset/list/public");
    }
    if (text === "Upload New Dataset") {
      navigate("/upload");
    }
    if (text === "Notes") {
      navigate("/dataset/Notes");
    }
  };

  // const handleFileTypeChange = (event) => {
  //   setFileType(event.target.value);
  //   setFile(null); // Reset file when file type changes
  //   setError(""); // Reset error message on file type change
  // };
  const extractColumnsFromFile = (uploadedFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        const firstLine = e.target.result.split('\n')[0];
        const columns = firstLine.split(',').map(col => col.trim());
        resolve(columns);
      };
  
      reader.onerror = () => reject("Error reading file");
      reader.readAsText(uploadedFile);
    });
  };
  const validateColumnNames = (columns) => {
    const invalidColumns = columns.map((col, index) => {
      // Generic patterns that suggest invalid column names
      const isInvalid = 
        typeof col !== 'string' ||                    // Not a string
        col.trim().length === 0 ||                    // Empty or just whitespace
        /^[\d:]/.test(col) ||                        // Starts with number or colon
        /["*\\/<>{}()|;]/.test(col) ||              // Contains special characters
        /^(null|undefined|nan)$/i.test(col) ||       // Common programming terms
        col.length > 50;                             // Unusually long for a column name
  
      if (isInvalid) {
        if (col){
          return col;
        }
        else{
          return "Empty column"
        }
      }
      return null;
    }).filter(Boolean);
  
    return invalidColumns;
  };
  const { getRootProps, getInputProps } = useDropzone({
    // accept:
    //   fileType === "csv" ? ".csv" : fileType === "pdf" ? "application/pdf" : "", // Allow only selected file type
    onDrop: (acceptedFiles) => {
      
        const invalidFiles = acceptedFiles.filter(
          (file) => file.type !== "application/pdf" & file.type !== "text/csv"
        );
        if (invalidFiles.length > 0) {
          setError("Please upload CSV or PDF files.");
        } else {
          if(files?.length>0){
            setFile([...files, ...acceptedFiles]); 
          }else{
            setFile(acceptedFiles); 
          }
          // For PDFs, store all selected files
          setError("");
        }
    },
    // multiple: fileType === "pdf", // Allow multiple files only for PDF
  });

  const generateUniqueFileName = (originalFileName) => {
    const timestamp = new Date().getTime();
    const fileExtension = originalFileName.split('.').pop();
    const nameWithoutExtension = originalFileName.split('.').slice(0, -1).join('.');
    return `${nameWithoutExtension}_${timestamp}.${fileExtension}`;
  };
  
  // Usage
  // Function to handle file upload to Azure
  // Handle file upload to Azure
  const handleUpload = async () => {
    if (!files || (Array.isArray(files) && files.length === 0)) {
      alert("Please select a file first!");
      return;
    }

    try {
      setLoading(true);
      // Create BlobServiceClient with the SAS token
      const blobServiceClient = new BlobServiceClient(
        `https://dspkstorage.blob.core.windows.net/?${sasToken}`
      );

      // Get the container client
      const containerClient =
        blobServiceClient.getContainerClient(containerName);

      if (Array.isArray(files)) {
        // Array to hold URLs of all uploaded files
        const fileUrls = [];

        // Handle multiple files (for PDFs)
        for (let i = 0; i < files.length; i++) {
          const currentFile = files[i];
          const blockBlobClient = containerClient.getBlockBlobClient(
            generateUniqueFileName(currentFile.name)
          );
          const uploadBlobResponse = await blockBlobClient.uploadBrowserData(
            currentFile
          );
          // console.log(
          //   `Upload successful: ${uploadBlobResponse.requestId} for file: ${currentFile.name}`
          // );

          // Construct the file URL and add to fileUrls array
          // const fileUrl = blockBlobClient.url.split("?")[0]; // Only take the base URL without query parameters
          const fileUrl = decodeURIComponent(blockBlobClient.url.split("?")[0]);
          fileUrls.push(fileUrl);
        }

        // Join the URLs for display or further use
        setFileTypePath(fileUrls);
        // console.log("All file URLs:", fileUrls);

        setLoading(false);
        setShowModel(true);
      } else {
        // Handle single file (for CSV or single PDF)
        const blockBlobClient = containerClient.getBlockBlobClient(encodeURIComponent(files.name).replace(/%20/g, "_").replace(/[()]/g, ""));
        const uploadBlobResponse = await blockBlobClient.uploadBrowserData(
          files
        );
        // console.log(`Upload successful: ${uploadBlobResponse.requestId}`);

        // Construct the file URL
        const fileUrl = blockBlobClient.url.split("?")[0]; // Only take the base URL without query parameters
        setShowModel(true);
        setFileTypePath(fileUrl);

        setLoading(false);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("File upload failed. Please try again.");
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setOpen(!isSmallScreen); // Update drawer state when screen size changes
  }, [isSmallScreen]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBars setOpen={setOpen} open={open} />

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Listitems handleNavigation={handleNavigation} open={open} />
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
          backgroundColor: "#EEEEEE",
          minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" }, // Adjust based on header height
        }}
      >
        <DrawerHeader />

        {showModel === false ? (
          <>
            {/* File Type Selection */}
            {/* <Box sx={{ mb: 3 }}>
              <Select
                value={fileType}
                onChange={handleFileTypeChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Select file type
                </MenuItem>
                <MenuItem value="csv">CSV</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </Box> */}

            {/* Drag and Drop or File Selection */}
            <Box
              {...getRootProps()}
              sx={{
                border: "2px dashed #ccc",
                padding: { xs: 3, sm: 4, md: 6 }, // Responsive padding for box
                textAlign: "center",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
                cursor: "pointer",
                minHeight: { xs: "150px", sm: "200px" }, // Responsive minHeight
              }}
            >
              <input {...getInputProps()} />
              {/* {file && Array.isArray(file) ? (
                <Typography variant="subtitle1">
                  Selected files: {file.map((f) => f.name).join(", ")}
                </Typography>
              ) : file ? (
                <Typography variant="subtitle1">
                  Selected file: {file.name}
                </Typography>
              ) : (
                <Typography variant="subtitle1">
                  Drag and drop files here, or click to select
                </Typography>
              )} */}


              <Typography variant="subtitle1">
                Drag and drop files here, or click to select
              </Typography>
            </Box>

            {files?.length > 0 ? (
              <ul>
                {files.map((f, index) => (
                  <li key={index}>
                    {index + 1}. {f.name}{" "}
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={() => setFile((prevFiles) => prevFiles.filter((_, i) => i !== index))}
                    >
                      Remove
                    </Button>
                  </li>
                ))}
              </ul>
            ) : (
              <></>
            )}


            {/* Display error message if invalid file type is uploaded */}
            {error && (
              <Typography color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}

            {/* Upload Button */}
            {loading ? (
              <CircularProgress />
            ) : (
              <Box sx={{ mt: { xs: 1, sm: 2 } }}>
                {" "}
                {/* Responsive margin */}
                <Button
                  variant="contained"
                  disabled={ !files}
                  onClick={handleUpload}
                >
                  Upload File
                </Button>
              </Box>
            )}
            <p style={{color: "yellow", backgroundColor:"black"}}>Note: File you are trying to upload needs proper column headers (For CSV)</p>
          </>
        ) : (
          <YourChildComponent
            setShowModel={setShowModel}
            file={files}
            fileTypePath={fileTypePath}
          />
        )}
      </Box>
    </Box>
  );
}
